<script>
  'use strict'

  import { tileX, tileY } from "../store/store";
  
  let x, y;
  tileX.subscribe(e => x = e);
  tileY.subscribe(e => y = e);

  // -------------------------------------------------
	$: tileX, updateGrid('--tileX', x);
  $: tileY, updateGrid('--tileY', y);

  // -------------------------------------------------
  function updateGrid(cssCustomPropertyKey, value) {
    if (value) {
      document.documentElement.style.setProperty(cssCustomPropertyKey, value);
      
      if (cssCustomPropertyKey == '--tileX') {
        tileX.set(value);
      } else {
        tileY.set(value);
      }
    }
  }

</script>

<div class="flex-24">
  <div>
    <label for="tileX">tiles X</label>
    <input type="number" name="tileX" id="tileX" min="0" bind:value={x} tabindex=1>
  </div>
  <div>
    <label for="tileY">tiles Y</label>
    <input type="number" name="tileY" id="tileY" min="0" bind:value={y} tabindex=2>
  </div>
</div>
